export interface LinkData {
  href: string;
  text: string;
}

const affiliatesHomeLink = process.env.NEXT_PUBLIC_AFFILIATE_URL
  ? process.env.NEXT_PUBLIC_AFFILIATE_URL
  : 'https://partners.npr.affiliates.asurion.com';

const comparionHomePlusFooterLinkData = [
  {
    href: `${affiliatesHomeLink}/home-plus/terms-conditions/`,
    text: 'Terms & Conditions',
  },
  {
    href: `${affiliatesHomeLink}/terms-conditions/`,
    text: 'Terms of Use',
  },
  {
    href: `${affiliatesHomeLink}/privacy-notice/`,
    text: 'Privacy Notice',
  },
  {
    href: 'https://privacyportal.onetrust.com/webform/c40dfca6-525d-44cd-82a0-f892f87753af/3628ce01-e3f3-4d8f-9da2-bc60dce6fab2',
    text: 'Do Not Sell My Information',
  },
];

export const homePlusFooterLinkData = [
  {
    href: 'https://www.asurion.com/about/reviews-and-ratings/',
    text: 'Customer Reviews',
  },
  {
    href: 'https://www.asurion.com/legal/partner/',
    text: 'Terms & Conditions',
  },
  { href: 'https://www.asurion.com/terms-conditions/', text: 'Terms of Use' },
  { href: 'https://www.asurion.com/privacy-notice/', text: 'Privacy Notice' },
  {
    href: 'https://privacyportal.onetrust.com/webform/c40dfca6-525d-44cd-82a0-f892f87753af/3628ce01-e3f3-4d8f-9da2-bc60dce6fab2',
    text: 'Do Not Sell My Information',
  },
];

export const footerLinks = (basePath?: string): LinkData[] => {
  switch (basePath) {
    case 'home-plus':
      return homePlusFooterLinkData;
    case 'home-plus-comparion':
      return comparionHomePlusFooterLinkData;
    default:
      return [];
  }
};
